<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    v-if="bulk_message != null"
    style="padding-left: 15px; padding-right: 15px"
>

    <div
        style="display: flex"
    >
        <div
            style="flex-grow: 1"
        >
            <v-text-field
                label="Bulk Message Name"
                :value="bulk_message.label"
                readonly
                disabled
            />
        </div>
        <div
            style="flex-grow: 0; margin-top: 15px; margin-left: 15px;"
        >
            <v-btn
                v-on:click="onClickBack"
            >
                Back
            </v-btn>
        </div>
    </div>

    <b>Message Patterns</b>
    <ul class="text-body-1">
        <li
            v-for="(pattern, index) in bulk_message.message_patterns"
            :key="index"
        >
            {{ pattern }}
        </li>
    </ul>

    <div
        style="display: flex"
    >
        <div
            style="flex-grow: 1;"
        >
            <v-text-field
                style="margin-top: 10px"
                label="Sentiment Forecast Time"
                :value="sentiment_forecast_time"
                disabled
                readonly
            />
        </div>
        <div
            style="flex-grow: 0; padding-top: 15px; margin-left: 15px;"
        >
            <v-btn
                color="primary"
                v-on:click="onClickUpdateForecast()"
            >
                Update Forecast...
            </v-btn>
        </div>
    </div>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickUpdateForecast()"
                >
                    <v-list-item-title>Update Forecast...</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="onClickEdit()"
                >
                    <v-list-item-title>View / Edit Forecast Model...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>
      

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >

        
    
        <template v-slot:item.recipient_endpoint="{ item }">
            {{$rc.pretty(item.recipient_endpoint, 'endpoint_no_parens')}}
        </template>

        <template v-slot:item.is_active_club_member="{ item }">
            {{prettyIsActiveClubMember(item)}}
        </template>

        <template v-slot:item.output_forecast="{ item }">
            <b>{{item.output_forecast}}</b>
        </template>

        

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickDetails(item)"
                >
                    <v-list-item-title>Details...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            bulk_message: null,
            results: [],
            full_text: null,
            last_update_time: null,

            headers: [
                { text: 'Phone Number', value: 'recipient_endpoint'},
                { text: 'First Name', value: 'first_name'},
                { text: 'Last Name', value: 'last_name'},
                { text: 'Consent (Promo)', value: 'consent_state_promotional'},
                { text: 'Club Member', value: 'is_active_club_member'},
                { text: 'Days Since Last Message', value: 'days_since_last_promotional_message'},
                { text: 'Days Since Purchase', value: 'days_since_last_non_club_purchase'},
                { text: 'Order Attribution %', value: 'bulk_message_order_attribution_percentile'},
                { text: 'Sentiment Forecast', value: 'output_forecast'},
                { text: 'Confidence (Percentile)', value: 'output_confidence'},
                { text: 'Action', value: 'action'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
        this.checkInferenceRequired();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),

        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/model/r1/inference',
            
                'params' : {
                        'bulk_message_id': this.$route.params.bulk_message_id,
                        'full_text': this.full_text,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                        this.bulk_message = data.bulk_message;
                        this.last_update_time = data.last_update_time;
                    },
            
                'on_error': 'Unable to complete API callZZ',
            });
        },


        onClickDetails(item)
        {
            this.$router.push({
                'name': 'model-r1-inference-detail',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                    'bulk_message_id': this.$route.params.bulk_message_id,
                    'bulk_message_recipient_id': item.bulk_message_recipient_id,
                }
            });
        },

        prettyIsActiveClubMember(item)
        {
            let value = item.is_active_club_member;

            if ( value == null ) return null;
            if ( value == true ) return 'Yes';
            return 'No';
        },

        onClickUpdateForecast()
        {
            this.$rc.startProcess({
                'type': 'inference-model-r1',

                'params': {
                    'bulk_message_id': this.$route.params.bulk_message_id
                },

                'title': 'Updating Sentiment Forecast',
                'finished_button_text': 'Ok',
                'failed_button_text': 'Ok',
            
                status: (pte) => {
                    switch (pte.state)
                    {
                        case 'failed': return 'Unable to update sentiment forecast';
                        case 'finished': return 'Sentiment forecast complete.';
                    }

                    if ( pte.progress_counter <= 2 )
                    {
                        return 'Getting ready to update sentiment forecast: this may take several minutes';
                    }

                    return 'Sentiment forecast complete: ' + pte.progress_counter;
                },
            
                on_finished: (pte) => {
                    this.doUpdate();
                },
            
                on_failed: (pte) => {
                    this.doUpdate();
                },
            
            });
        },

        onClickEdit()
        {
            this.$router.push({
                'name': 'model-r1-edit',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                    'bulk_message_id': this.$route.params.bulk_message_id,
                }
            });
        },

        onClickBack()
        {
            this.$router.push({
                'name': 'view-bulk-message',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                    'bulk_message_id': this.$route.params.bulk_message_id,
                }
            });
        },

        checkInferenceRequired()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/model/r1/inference-required/:bulk_message_id',
            
                'params' : {
                        'bulk_message_id': this.$route.params.bulk_message_id,
                    },
            
                'on_success': (data) => {
                        if ( data.inference_required )
                        {
                            this.confirmInferenceOnLoad();
                        }
                    },
            
                'on_error': 'Unable to check if inference is required',
            });
        },

        confirmInferenceOnLoad()
        {
            this.$rc.confirm({
                'title': 'Update Forecast',
                'body': 'Some (or all) of the recipients on your bulk message do not have an update to date sentiment forecast.<br/><br/>Would you like to update the sentiment forecast?',
                'btn_text_ok': 'Update Forecast',
                'btn_text_cancel': 'Not now',
                'on_ok': () => {
                    this.onClickUpdateForecast();
                },
            });
        },
    },

    computed: {
        title() {
            if ( this.bulk_message == null )
                return 'Bulk Message Sentiment Forecast';

            return 'Sentiment Forecast: '+this.bulk_message.label;
        },

        sentiment_forecast_time()
        {
            if ( this.last_update_time == null )
                return 'No sentiment forecast prepared';

            return this.$rc.pretty(this.last_update_time, 'date_and_time');
        },
    },
}
</script>

<style lang="scss" scoped>
</style>